<template>

</template>

<script>
import router from '../../router/router';
import Auth from '../../utils/auth';


export default {
  name: 'SchoolLogin',
  meta:{page:true},
  data() {
    return {
        
    }
  },
    created() {
      this.logout();
  },
  methods: {
        logout() {
            Auth.clearToken();
//          router.replace({path:'/login/logout'});
            this.$router.push({path:'/login/passwd'});
        }
  }
}
</script>
</style>




// WEBPACK FOOTER //
// src/components/page/SchoolLogout.vue